<template>
  <div
    v-if="
      auction.auctionStatus == 'REDISTRIBUTING_1' ||
        auction.auctionStatus == 'REDISTRIBUTING_2' ||
        (auction.auctionStatus == 'CLOSED' && auction.auctionType == 'REDISTRIBUTE')
    "
    class="flex"
  >
    <a
      href="#"
      class="shadow border-1 rounded-t w-28 text-center h-8 md:h-10 flex items-center justify-center mx-2 bg-corepla-bg-light border-black  border-b-0 "
      :class="{ 'font-bold !bg-corepla-bg-dark text-white !shadow-2xl': visibleTab == 'standard' }"
      @click.prevent="emit('changeTab', 'standard');"
    >
      {{ $t('lot.standard') }}
    </a>
    <a
      href="#"
      class="shadow border-1 rounded-t w-28 text-center h-8 md:h-10 flex items-center justify-center mx-2 bg-corepla-bg-light"
      :class="{ 'font-bold !bg-corepla-bg-dark text-white !shadow-2xl': visibleTab == 'redistribute' }"
      @click.prevent="emit('changeTab', 'redistribute');"
    >
      {{ $t('lot.redistribute') }}
    </a>
  </div>
</template>

<script setup>
import { watch } from 'vue';

const props = defineProps({
  visibleTab: {
    type: String,
    required: true
  },
  auction: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['changeTab'])

watch(
  () => props.auction.auctionStatus,
  (newStatus) => {
    if (newStatus === 'REDISTRIBUTING_1' || newStatus === 'REDISTRIBUTING_2') {
      emit('changeTab', 'redistribute')
    } else {
      emit('changeTab', 'standard')
    }
  }
);

</script>